import React, { useState, useEffect } from 'react';
import './CardLawyerAnswers.scss';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { getRecentAnswers } from '../../../store/actions/UserAction';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

const useStyles = makeStyles({
  button: {
    textTransform: 'inherit',
    alignItems: 'flex-start',
    border: '1px solid #e7e7e7',
    borderRadius: 4,
    margin: '0 0 17px 0',
    width: '99%'
  },
  label: {
    display: 'flex',
    flexDirection: 'column',
  }
})

const CardLawyerAnswers = ({ authClient, getRecentAnswers }) => {

  const classes = useStyles()
  const history = useHistory()

  const [didSet, setDidSet] = useState(false)

  const goToAnswer = (id) => {
    history.push(`/comunidad/pregunta/${id}`)
  }

  useEffect(() => {
    if (!didSet) {
      try {
        getRecentAnswers(authClient.uid)
        setDidSet(true)
      } catch (error) {
        console.log('error', error);
      }
    }
  }, [authClient.uid, getRecentAnswers, didSet])

  return (
    <>
      <section className="cardLawyerAnswers">
        <header className="cardLawyerAnswers_header">
          <p className="cardLawyerAnswers_title">Respuestas en comunidad</p>
        </header>
        <div className="cardLawyerAnswers_buttonContainer">
          {authClient &&
          authClient.recentAnswers &&
          Array.isArray(authClient.recentAnswers) ?
            (authClient.recentAnswers.map((elem, index) => {
              if (index <= 4) {
                return (
                  <Button
                    onClick={() => goToAnswer(elem.id)}
                    classes={{
                      root: classes.button,
                      label: classes.label
                    }}
                  >
                    <p className="cardLawyerAnswers_titleQuestions">
                      {elem && elem.title ?
                        elem.title.length > 50 ?
                            `${elem.title.slice(0, 50)}...` :
                            elem.title ? elem.title :
                            '' : ''
                      }                                            
                    </p>
                    <div className="cardLawyerAnswers_container">
                      <img
                        src='/img/community/public-view/message.svg'
                        alt='iconResponse'
                        className="cardLawyerAnswers_img"
                      />
                      <span className="cardLawyerAnswers_answers">{elem && elem.numberAnswers ? elem.numberAnswers : 0} respuestas</span><span className="cardLawyerAnswers_date">{moment.unix(elem.createdAt.seconds).format('DD MMMM YYYY')}</span>
                    </div>
                  </Button>
                )
              }
            })
            ) : ''
          }
        </div>
      </section>
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  getRecentAnswers: lawyerUid => dispatch(getRecentAnswers(lawyerUid))
})

export default connect(null, mapDispatchToProps)(CardLawyerAnswers);
